import Lottie from 'lottie-react';

import { cn } from '@/lib/utils';
import mailConfirmationAnimation from '@/pages/assets/animations/mail-confirmation.json';

interface MailConfirmationAnimationProps {
    className?: string;
    loop?: boolean;
}

export default function MailConfirmationAnimation({
    className,
    loop = false,
}: MailConfirmationAnimationProps) {
    return (
        <Lottie
            animationData={mailConfirmationAnimation}
            loop={loop}
            className={cn('w-full h-full', className)}
        />
    );
}
